import { mergeConstellationAppearance } from "@chuzi/shared/realms/cosmos/components";
import type { CosmosWorldNavLevel } from "./cosmos-world-mover";

export function cosmosBrowseShowNebulaStoryLabels(navLevel: CosmosWorldNavLevel): boolean {
  return navLevel === "nebula";
}

export function cosmosBrowseShowSceneLabels(navLevel: CosmosWorldNavLevel): boolean {
  return navLevel === "story";
}

export function cosmosBrowseClusterLabelHidden(_navLevel: CosmosWorldNavLevel): boolean {
  return false;
}

export function cosmosBrowseAppearance(navLevel: CosmosWorldNavLevel) {
  return mergeConstellationAppearance({
    showSceneLabels: cosmosBrowseShowSceneLabels(navLevel),
  });
}
